import React, { useRef, useState, useEffect } from 'react';
import { Button, Row, Col, Modal, Form, OverlayTrigger, Tooltip} from 'react-bootstrap';
import { connect } from 'react-redux';
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import BlockUi from 'react-block-ui';
import useMonitorAPIService from '../../services/monitorapiservice';
import { Switch } from "devextreme-react";
import { NumberBox } from "devextreme-react/number-box";
import Toastr from '../utils/toastr';
import DualListBox from 'react-dual-listbox';
import { setAlarms } from '../../redux/parametersSlice';

function Alarms(props) {

    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const toastrRef = useRef(null);

    const [agents, setAgents] = useState([]);

    const [timeInQueue, setTimeInQueue] = useState(0);
    const [maxConversation, setMaxConversation] = useState(0);
    const [maxPauseTime, setMaxPauseTime] = useState(0);
    const [maxDroppedCalls, setMaxDroppedCalls] = useState(0);
    const [callDuration, setCallDuration] = useState(0);
    const [callPeriod, setCallPeriod] = useState(0);
    const [dialersActivity, setDialersActivity] = useState(0);
    const [formOpenWithoutActivity, setFormOpenWithoutActivity] = useState(0);
    const [excludeAgents, setExcludeAgents] = useState([]);
    const [notify, setNotify] = useState(false);
    const [notifyAudio, setNotifyAudio] = useState(false);

    const { updateAlarmsParameter, getSupervisedAgents } = useMonitorAPIService();

    useEffect(() => {


    }, [props]);


    const onShow = e => {
        setLoading(true);
        getSupervisedAgents(props.token, (res) => {
            if (res.data != null && res.data.length > 0) {
                let agents = res.data.map(x => { return { label: x.name, value: x.userId } });
                setAgents(agents);
                setTimeInQueue(props.timeInQueue);
                setMaxConversation(props.maxConversation);
                setMaxPauseTime(props.maxPauseTime);
                setMaxDroppedCalls(props.maxDroppedCalls);
                setCallDuration(props.callDuration);
                setCallPeriod(props.callPeriod);
                setDialersActivity(props.dialersActivity);
                setFormOpenWithoutActivity(props.formOpenWithoutActivity);
                setExcludeAgents(props.excludeAgents);
                setNotify(props.notify);
                setNotifyAudio(props.notifyAudio);
            }
            setLoading(false);
        });
    }

    const setAlarms = e => {
        setLoading(true);
        let data = {
            userId: localStorage.getItem("id"),
            timeInQueue: timeInQueue,
            maxConversation: maxConversation,
            maxPauseTime: maxPauseTime,
            maxDroppedCalls: maxDroppedCalls,
            callDuration: callDuration,
            callPeriod: callPeriod,
            dialersActivity: dialersActivity,
            formOpenWithoutActivity: formOpenWithoutActivity,
            notify: notify,
            notifyAudio: notifyAudio,
            excludeAgents: excludeAgents
        };

        updateAlarmsParameter(props.token, data, (res) => {
            if (!res) {
                toastrRef.current.setType("error");
                toastrRef.current.setMessage(t("error"));
                toastrRef.current.show();
            } else {
                toastrRef.current.setType("success");
                toastrRef.current.setMessage(t("dataupdated"));
                toastrRef.current.show();
                props.setAlarms(data);
                props.toggleModal();
            }

            setLoading(false);
        })
    }

    return (<>
        <Modal rtl={props.rtl} show={props.show} onHide={props.toggleModal} onShow={onShow} size="xl">
            <BlockUi tag="div" blocking={loading} color="#009ef7" message={t("pleasewait")}>
                <Modal.Header>
                    <Modal.Title>
                        <FontAwesomeIcon icon={duotone("bell")} /> {t("alarms")}
                    </Modal.Title>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {t("close")}
                        </Tooltip>}>
                        <Button onClick={props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                    </OverlayTrigger>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <div className="dx-fieldset">
                                <div className="dx-field">
                                    <div className="dx-field-label" style={{ "width": "70%" }}><Form.Label>{t("maxqueuetime")}</Form.Label></div>
                                    <div className="dx-field-value" style={{ "width": "30%" }}>
                                        <NumberBox style={{ "float": "right" }}
                                            rtlEnabled={props.rtl}
                                            showSpinButtons={true}
                                            value={timeInQueue}
                                            onValueChange={setTimeInQueue} width={"100px"} />

                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className="dx-fieldset">
                                <div className="dx-field">
                                    <div className="dx-field-label" style={{ "width": "70%" }}><Form.Label>{t("maxconvtime")}</Form.Label></div>
                                    <div className="dx-field-value" style={{ "width": "30%" }}>
                                        <NumberBox style={{ "float": "right" }}
                                            rtlEnabled={props.rtl}
                                            showSpinButtons={true}
                                            value={maxConversation}
                                            onValueChange={setMaxConversation} width={"100px"}
                                        />

                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>

                        <Col>
                            <div className="dx-fieldset">
                                <div className="dx-field">
                                    <div className="dx-field-label" style={{ "width": "70%" }}><Form.Label >{t("maxpausetime")}</Form.Label></div>
                                    <div className="dx-field-value" style={{ "width": "30%" }}>
                                        <NumberBox style={{ "float": "right" }}
                                            rtlEnabled={props.rtl}
                                            showSpinButtons={true}
                                            value={maxPauseTime}
                                            onValueChange={setMaxPauseTime}
                                            width={"100px"}
                                        />

                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className="dx-fieldset">
                                <div className="dx-field">
                                    <div className="dx-field-label" style={{ "width": "70%" }}><Form.Label >{t("maxmissedcalls")}</Form.Label></div>
                                    <div className="dx-field-value" style={{ "width": "30%" }}>
                                        <NumberBox style={{ "float": "right" }}
                                            rtlEnabled={props.rtl}
                                            showSpinButtons={true}
                                            value={maxDroppedCalls}
                                            onValueChange={setMaxDroppedCalls}
                                            width={"100px"} />

                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="dx-fieldset">
                                <div className="dx-field">
                                    <div className="dx-field-label" style={{ "width": "70%" }}><Form.Label >{t("mincallduration")}</Form.Label></div>
                                    <div className="dx-field-value" style={{ "width": "30%" }}>
                                        <NumberBox style={{ "float": "right" }}
                                            rtlEnabled={props.rtl}
                                            showSpinButtons={true}
                                            value={callDuration}
                                            onValueChange={setCallDuration}
                                            width={"100px"}
                                        />

                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className="dx-fieldset">
                                <div className="dx-field">
                                    <div className="dx-field-label" style={{ "width": "70%" }}><Form.Label >{t("callperiod")}</Form.Label></div>
                                    <div className="dx-field-value" style={{ "width": "30%" }}>
                                        <NumberBox style={{ "float": "right" }}
                                            rtlEnabled={props.rtl}
                                            showSpinButtons={true}
                                            value={callPeriod}
                                            onValueChange={setCallPeriod}
                                            width={"100px"}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="dx-fieldset">
                                <div className="dx-field">
                                    <div className="dx-field-label" style={{ "width": "70%" }}><Form.Label >{t("dialersalarm")}</Form.Label></div>
                                    <div className="dx-field-value" style={{ "width": "30%" }}>
                                        <NumberBox style={{ "float": "right" }}
                                            rtlEnabled={props.rtl}
                                            showSpinButtons={true}
                                            value={dialersActivity}
                                            onValueChange={setDialersActivity}
                                            width={"100px"}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className="dx-fieldset">
                                <div className="dx-field">
                                    <div className="dx-field-label" style={{ "width": "70%" }}><Form.Label >{t("formopenwithoutactivity")}</Form.Label></div>
                                    <div className="dx-field-value" style={{ "width": "30%" }}>
                                        <NumberBox style={{ "float": "right" }}
                                            showSpinButtons={true}
                                            rtlEnabled={props.rtl}
                                            value={formOpenWithoutActivity}
                                            onValueChange={setFormOpenWithoutActivity}
                                            width={"100px"}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="dx-fieldset">
                                <div className="dx-field">
                                    <Form.Label >{t("excludeagents")}</Form.Label>
                                    <DualListBox
                                        options={agents}
                                        selected={excludeAgents}
                                        onChange={(value) => setExcludeAgents(value)}
                                        icons={{
                                            moveLeft: <FontAwesomeIcon icon={duotone("left")} />,
                                            moveAllLeft: [
                                                <FontAwesomeIcon key={0} icon={duotone("left")} />,
                                                <FontAwesomeIcon key={1} icon={duotone("left")} />,
                                            ],
                                            moveRight: <FontAwesomeIcon icon={duotone("right")} />,
                                            moveAllRight: [
                                                <FontAwesomeIcon key={0} icon={duotone("right")} />,
                                                <FontAwesomeIcon key={1} icon={duotone("right")} />,
                                            ]
                                        }}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="dx-fieldset">
                                <div className="dx-field">
                                    <div className="dx-field-label"> <Form.Label >{t("enablenotification")}</Form.Label></div>
                                    <div className="dx-field-value">
                                        <Switch rtlEnabled={props.rtl} switchedOnText={t("yes")} switchedOffText={t("no")} value={notify} onValueChange={setNotify} text />
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className="dx-fieldset">
                                <div className="dx-field">
                                    <div className="dx-field-label"> <Form.Label >{t("enableaudionotification")}</Form.Label></div>
                                    <div className="dx-field-value">
                                        <Switch rtlEnabled={props.rtl} switchedOnText={t("yes")} switchedOffText={t("no")} value={notifyAudio} onValueChange={setNotifyAudio} text />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={setAlarms}>
                        <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {t("send")}
                    </Button>
                </Modal.Footer>
            </BlockUi>
        </Modal>
        <Toastr ref={toastrRef} />
    </>)
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        timeInQueue: state.parameters.timeInQueue,
        maxConversation: state.parameters.maxConversation,
        maxPauseTime: state.parameters.maxPauseTime,
        maxDroppedCalls: state.parameters.maxDroppedCalls,
        callDuration: state.parameters.callDuration,
        callPeriod: state.parameters.callPeriod,
        dialersActivity: state.parameters.dialersActivity,
        formOpenWithoutActivity: state.parameters.formOpenWithoutActivity,
        excludeAgents: state.parameters.excludeAgents,
        notify: state.parameters.notify,
        notifyAudio: state.parameters.notifyAudio,
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, { setAlarms })(Alarms);